import type { GetDecisionLabelParams } from './types';

const getDecisionLabel = ({
  userName,
  decidedAt,
  isClosedOperation,
  isPending,
}: GetDecisionLabelParams): string | null => {
  const trimmedUserName = userName.trim();
  const trimmedDecidedAt = decidedAt.trim();

  if (isClosedOperation && isPending) return 'Sin decisión';
  if (trimmedUserName && trimmedDecidedAt)
    return `${trimmedUserName} - ${trimmedDecidedAt}`;
  if (!isPending) return null;

  return 'Esperando decisión';
};

export { getDecisionLabel };
